/*
 * Opens the theme cart drawer when the Bundle Kit Pro app adds to cart.
 *
 * The app already announces every add-to-cart with its own `cart:update` event
 * (detail.sourceId === 'bundle-builder'), fired on both the desktop
 * (bundle-builder.js) and mobile (bundle-mobile-controller.js) flows via
 * BundleCartIntegration.openCartDrawer(). It targets a different theme's drawer
 * conventions, though, so nothing here reacts. Bridge that event to the one our
 * <oilogic-cart-drawer> listens for; the drawer then opens and refetches
 * /cart.js on its own (no cart payload needed).
 */
(() => {
  document.addEventListener('cart:update', (event) => {
    if (event.detail?.sourceId !== 'bundle-builder') return;
    document.dispatchEvent(
      new CustomEvent('oilogic:cart:added', { bubbles: true, detail: {} })
    );
  });
})();
